import { render, staticRenderFns } from "./ResourceGrid.vue?vue&type=template&id=04a76079&scoped=true&"
import script from "./ResourceGrid.vue?vue&type=script&lang=js&"
export * from "./ResourceGrid.vue?vue&type=script&lang=js&"
import style0 from "./ResourceGrid.vue?vue&type=style&index=0&id=04a76079&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a76079",
  null
  
)

export default component.exports